import { CareElementType } from "./CareElementType";

export class BaseCareElement {
    public Name: string;
    public SubSectionName?: string;
    public CareElementType: CareElementType;
}
